import React, { Fragment, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import MonedaSelector from "../UI/MonedaSelector/MonedaSelector";
import MenuUsuario from "../MenuUsuario/MenuUsuario";
import MenuApps from "../MenuApps/MenuApps";
import UltimaActualizacion from "../UltimaActualizacion/UltimaActualizacion";
import ButtonEjecucionPagina from "../EjecucionPagina/ButtonEjecucionPagina";
import ButtonTomarEnCuentaInflacion from "../Configuraciones/TomarEnCuentaInflacion/ButtonTomarEnCuentaInflacion";
import MoreVertIcon from '@material-ui/icons/MoreVert';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import FechaFijaSelector from "../Configuraciones/FechaFijaSelector/FechaFijaSelector";
import MenuConfiguraciones from "../Configuraciones/MenuConfiguraciones/MenuConfiguraciones";
import { pathNamePages } from "../../assets/shared/pathnames";

const useStyles = makeStyles((theme) => ({
  toolbarUsuario: {
    display: 'none',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  mobileToolbarUsuario: {
    display: 'flex',
    alignItems: 'center',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  },
  UsuarioLog: {
    display: "flex",
    flexDirection: "row",
    alignSelf: "flex-end",
  },
  MonedaSelector: {
    color: "white",
    marginLeft: "10px",
    marginRight: "10px",
  },  
  menuItem: {
    display: "flex", 
    flexDirection: "row",
    alignItems: "center",
    justifyContent: 'flex-start',
  },
}));

const ToolbarComponents = () => {
  const classes = useStyles();  
  const showBack = global.window.location.pathname.includes(pathNamePages.cliente) ||
    global.window.location.pathname.includes(pathNamePages.proveedor);

  const onSeleccionarMoneda = (value) => {
    console.log(value);
    handleClose();
  }
  
  const monedaSelect = () => {
    return (
      <div className={classes.Selector}>
        <MonedaSelector letraColor="white" onSeleccionarMoneda={onSeleccionarMoneda} />
      </div>
    )
  }

  //#region  Toolbar Usuario
  const toolbarUsuario = () => {
    return (
      <Fragment>
        <ButtonEjecucionPagina />
        <ButtonTomarEnCuentaInflacion puedeModificarInflacion={!showBack}/>
        {monedaSelect()}
        <FechaFijaSelector />
        <UltimaActualizacion ultPath={global.window.location.href} iconSize="25px" />
        <div className={classes.MenuConfiguraciones}
          style={{ display: "flex", alignItems: "center" }}
        >
          <MenuConfiguraciones iconSize="25px" />
        </div>
        <MenuApps iconSize="25px" />
        <div className={classes.UsuarioLog}>
          <MenuUsuario />
        </div>
      </Fragment>
    )
  }

  //#endregion

  //#region Mobile Toolbar Usuario
  const ITEM_HEIGHT = 48;

  const [anchorEl, setAnchorEl] = useState(null);
  const openMore = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };
  
  const mobileToolbarUsuario = () => {
    return (
      <Fragment>
        <ButtonEjecucionPagina />
        <div className={classes.MenuConfiguraciones} style={{ display: 'flex', alignItems: 'center' }}>
          <MenuConfiguraciones iconSize="25px" />
        </div>
        <MoreVertIcon
          onClick={handleClick}
          style={{ color: 'white', fontSize: '1.8rem', cursor: 'pointer' }}
        />
        <Menu
          id="long-menu"
          anchorEl={anchorEl}
          keepMounted
          open={openMore}
          onClose={handleClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              backgroundColor: 'RGB(81,81,81)',
            },
          }}
        >
          <MenuItem className={classes.menuItem}>
            <ButtonTomarEnCuentaInflacion  puedeModificarInflacion={!showBack} />
          </MenuItem>
          <MenuItem className={classes.menuItem} style={{ color: 'white' }}>
            <Typography style={{ marginInline: '10px' }}>Moneda: </Typography>     
            {monedaSelect()}     
          </MenuItem>
          <MenuItem className={classes.menuItem}>
            <FechaFijaSelector iconSize="25px" color={'white'} />
          </MenuItem>
          <MenuItem className={classes.menuItem}>
            <UltimaActualizacion ultPath={global.window.location.href} iconSize="25px" color={'white'} />
          </MenuItem>
          <MenuItem className={classes.menuItem}>
            <MenuApps iconSize="25px" />
          </MenuItem>
        </Menu>
      </Fragment>
    );
  }

  //#endregion

  return (
    <Fragment>
      <div className={classes.toolbarUsuario}>
        {toolbarUsuario()}
      </div>
      
      <div className={classes.mobileToolbarUsuario}>
        {mobileToolbarUsuario()}
      </div>
    </Fragment>
  );
};

export default ToolbarComponents;
